import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-[14px] w-[14px] shrink-0 rounded-sm border border-white/40 ring-offset-background focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer transition-all duration-150 hover:bg-white/10 hover:border-active-gold/80 hover:scale-[1.08] hover:shadow-sm',
      'data-[state=checked]:bg-active-gold/75 data-[state=checked]:hover:bg-active-gold/85 data-[state=checked]:border-active-gold data-[state=checked]:text-active-gold data-[state=checked]:shadow-sm',
      className
    )}
    {...props}
  />
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
